import SvgRecordAudio from "../consult-form-icons/SvgRecordAudio";
import SvgRecording from "../consult-form-icons/SvgRecording";
// import { useRecorder } from "./audio-record/useOldRecorder";
import { useUploadAudio } from "@/api/AppApi/services/upload-file";
import { useEffect } from "react";
import { useIsMobile } from "@/hooks/useIsMobile";
import useRecorder from "./audio-record/useRecorder";
import CustomButton, {
  BtnRadius,
  BtnSizes,
  BtnTypes,
} from "@/app/components/lib/CustomButton";
import { secondsToMS } from "@/utils/functions/date-time-functions";
import SpinnerForBtn from "@/app/components/lib/loaders/SpinnerForBtn";
import { useTranslation } from "@/hooks/localization/useTranslations";

// export interface RecordInfo {
//   url: string;
//   duration: string;
// }

interface Props {
  addToRecordList: (url: string) => void;
}
const ConsultRecordedFiles: React.FC<Props> = ({ addToRecordList }) => {
  const mobile = useIsMobile();
  const t = useTranslation();
  const {
    audioBlob,
    setAudioBlob,
    recording,
    startRecording,
    stopRecording,
    recodingTime,
    mp3Converting,
  } = useRecorder();
  const uploadAudio = useUploadAudio({
    onSuccess: (res) => {
      addToRecordList(res.result.absolute_url);
      setAudioBlob(null);
    },
    onError: (err) => {
      setAudioBlob(null);
      if (err.response?.status === 422) {
      } else {
      }
    },
  });
  useEffect(() => {
    if (!audioBlob) return;
    uploadAudio.mutate({ blob: audioBlob });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [audioBlob]);

  return (
    <>
      <CustomButton
        type={recording ? BtnTypes.green : BtnTypes.neutral}
        size={BtnSizes.small}
        radius={BtnRadius.small}
        onClick={recording ? stopRecording : startRecording}
      >
        {recording ? (
          <>
            <SvgRecording />
            {`${secondsToMS(recodingTime)} ${t.stop_recording} `}
          </>
        ) : (
          <>
            {mp3Converting || uploadAudio.isLoading ? (
              <SpinnerForBtn dark />
            ) : (
              <>
                <SvgRecordAudio />
                {!mobile && t.record_voice_message}
              </>
            )}
          </>
        )}
      </CustomButton>
    </>
  );
};

export default ConsultRecordedFiles;
